import "./ReactVisBase.css";
import * as React from "react";
import { VisState } from "../helpers/vis";
import LoaderDebug from "./LoaderDebug";
import GlobalSpinner from "./GlobalSpinner";

export default function ReactVisBase(
  attrs: React.HTMLAttributes<HTMLDivElement> & { state: VisState },
): React.ReactElement {
  const [debugMode, setDebugMode] = React.useState(false);
  const [isReady, setIsReady] = React.useState(false);
  attrs.state.onReady = () => setIsReady(true);

  React.useEffect(() => {
    window.addEventListener("keydown", (e) => {
      if (e.code === "F3") {
        setDebugMode((m) => !m);
      }
    });
  }, []);

  const divAttrs = Object.fromEntries(Object.entries(attrs).filter(([k]) => k !== "state"));

  return (
    <>
      {!isReady ? (
        <div style={{ height: "200px", width: "200px" }}>
          <GlobalSpinner isView={true} />
        </div>
      ) : (
        <>
          {debugMode && attrs.state && <LoaderDebug params={attrs.state.params} />}
          <div {...divAttrs} />
        </>
      )}
    </>
  );
}
